var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{class:{'setting':true,'pulse-shrink':_vm.t},on:{"click":_vm.hx}},[_vm._v("系统设置")])
}
var staticRenderFns = []

export { render, staticRenderFns }